import React from 'react'
import PropTypes from 'prop-types'
import Image from 'react-image'
import NoImage from 'assets/images/no-image.jpg'
import ThumbnailLoader from 'components/shared/loaders/thumb'
import PaymentDetailsInfo from './payment-details-info'

const PaymentDetailsFields = ({ bookingDetails: { space, checkIn, imageSrc, imageAlt, checkOut, noOfGuests, amount, currency } }) => (
  <div className="booking-payment-details">
    <div className="booking-payment-details-header p-5 flex flex-col justify-center items-center bg-secondary-lightgray">
      <h3 className="text-primary-orange text-xl font-semibold text-center">{`Coworking Space for ${noOfGuests} at ${space}`}</h3>
      <Image
        src={[imageSrc, NoImage]}
        alt={imageAlt}
        className="rounded w-full"
        loader={<ThumbnailLoader />} />
      <ul className="booking-payment-details-header-info md:w-1/2 w-full">
        <li className="flex justify-between my-3">
          <p className="text-primary-orange font-bold text-lg">Check In</p>
          <p className="font-normal text-lg">{checkIn}</p>
        </li>
        <li className="flex justify-between my-3">
          <p className="text-primary-orange font-bold text-lg">Check Out</p>
          <p className="font-normal text-lg">{checkOut}</p>
        </li>
        <li className="flex justify-between my-3">
          <p className="text-primary-orange font-bold text-lg">Number of Guests</p>
          <p className="font-normal text-lg">{noOfGuests}</p>
        </li>
      </ul>
    </div>
    <PaymentDetailsInfo amount={`${currency} ${amount}`} />
  </div>
)

PaymentDetailsFields.propTypes = {
  bookingDetails: PropTypes.object,
}

export default PaymentDetailsFields
